import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Immutable from 'immutable'
import { clearItineraryGeofenceAlerts, getItineraryGeofenceAlerts } from '../../../../../actions'
import { ITINERARY_GEOFENCE_ALERT_COLUMNS } from '../../../../../config/columns'
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants'
import Table from '../../../../common/Table'

const ItineraryGeofenceAlerts = ({
  itineraryId,
  dispatchGetItineraryGeofenceAlerts,
  dispatchClearItineraryGeofenceAlerts,
  geofenceAlerts,
  geofenceAlertsLoading,
}) => {

  useEffect(() => {
    dispatchGetItineraryGeofenceAlerts(itineraryId)
    return () => {
      dispatchClearItineraryGeofenceAlerts()
    }
  }, [])

  return (
    <Table
      manual={false}
      data={geofenceAlerts}
      filterable
      loading={geofenceAlertsLoading}
      columns={ITINERARY_GEOFENCE_ALERT_COLUMNS}
      defaultPageSize={DEFAULT_PAGE_SIZE}
    />
  )
}

ItineraryGeofenceAlerts.propTypes = {
  itineraryId: PropTypes.number.isRequired,
  dispatchGetItineraryGeofenceAlerts: PropTypes.func.isRequired,
  dispatchClearItineraryGeofenceAlerts: PropTypes.func.isRequired,
  geofenceAlerts: PropTypes.arrayOf(Immutable.List).isRequired,
  geofenceAlertsLoading: PropTypes.bool,
}

ItineraryGeofenceAlerts.defaultProps = {
  geofenceAlertsLoading: false,
}

const mapStateToProps = ({ ItineraryUnit }) => ({
  geofenceAlerts: ItineraryUnit.Itinerary.getIn(['current', 'geofenceAlerts']).toJS(),
  geofenceAlertsLoading: ItineraryUnit.Itinerary.getIn(['current', 'geofenceAlertsLoading']),
})

const mapDispatchToProps = {
  dispatchGetItineraryGeofenceAlerts: getItineraryGeofenceAlerts,
  dispatchClearItineraryGeofenceAlerts: clearItineraryGeofenceAlerts
}

export default connect(mapStateToProps, mapDispatchToProps)(ItineraryGeofenceAlerts);